import React from 'react'

import './editUserEmailAddress.css'

const EditUserEmailAddress = ({id, userData}: any) => {
  return (
    <div>EditUserEmailAddress</div>
  )
}

export default EditUserEmailAddress